class CardDelegate {
  article
  constructor (card_class_list) {
    this.card_class_list = card_class_list
  }

  setArticle (article) {
    this.article = article
    return this
  }

  initCards () {
    this.cards = this.card_class_list.reduce((pre, construct) => {
      pre[construct.name] = new construct(this.article)
      return pre
    }, {})
    return this
  }

  // 处理卡片DOM
  handleCardDOM (node) {
    return Object.values(this.cards).reduce((pre,cur) => {
      return cur.addCards(pre)
    }, node)
  }

  // 触发卡片请求
  triggerCardDataRequest () {
    this.requests = {}
    Object.values(this.cards).forEach(cards => cards.request())
  }
}

export default CardDelegate